<template>
  <v-expansion-panels
    v-model="panel"
    class="mt-3"
  >
    <v-expansion-panel>
      <v-expansion-panel-header color="third">
        <template #actions>
          <v-icon color="white">
            $expand
          </v-icon>
        </template>
        <v-card-title class="third white--text font-weight-bold">
          <span class="ml-2">{{ tableTitle }}</span>
        </v-card-title>
        <v-spacer />
        <v-icon size="28" color="white" class="justify-end px-4" @click.stop="downloadTableContent">mdi-export</v-icon>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-container>
          <v-data-table
            :headers="headers"
            :hide-default-footer="true"
            :items="recuperations"
            :items-per-page="-1"
            height="350"
            class="elevation-3"
          />
        </v-container>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import { downloadCSV } from '../../../helpers/utils';

export default {
  props: {
    instructor: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  setup () {
    const headers = ref([
      { text: 'Destinataire', value: 'participant' },
      { text: 'Date', value: 'horse' },
      { text: 'Quantité', value: 'presence' },
      { text: 'Activité', value: 'recovery' }
    ]);
    const panel = ref(0);
    const tableTitle = ref('Historique des récupérations données');

    // TODO: fill with recuperation array
    const recuperations = computed(() => []);

    const downloadTableContent = () => {
      downloadCSV([{ headers: headers.value, data: recuperations.value }], tableTitle.value);
    };

    return { headers, panel, downloadTableContent, recuperations, tableTitle };
  }
};
</script>
